import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, HostListener, ViewChild, Output, Input, Optional, SkipSelf, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i4 from '@engineering11/ui-lib/e11-icon';
import { E11IconModule } from '@engineering11/ui-lib/e11-icon';
import * as i3 from '@engineering11/ui-lib/e11-input-label';
import { E11InputLabelModule } from '@engineering11/ui-lib/e11-input-label';
import * as i1 from '@angular/forms';
import { UntypedFormGroup, FormGroup, Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { isValidNumberForRegion } from 'libphonenumber-js';
import { getCountries, parsePhoneNumber, AsYouType, getCountryCallingCode } from 'libphonenumber-js/max';

const Countries = {
    AF: 'Afghanistan',
    AX: 'AlandIslands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos Keeling Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo Democratic Republic',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: 'CoteDIvoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'CzechRepublic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island Mcdonald Islands',
    VA: 'Holy See Vatican City State',
    HN: 'Honduras',
    HK: 'HongKong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle Of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea, Republic of',
    KP: "Korea, Democratic People's Republic of",
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao Peoples Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    MK: 'Macedonia',
    MKD: 'Republic of North Macedonia',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent And Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome And Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia And Sandwich Island',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SS: 'South Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard And Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SX: 'Sint Maarten (Dutch part)',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'TimorLeste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad And Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks And Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Virgin Islands British',
    VI: 'Virgin Islands US',
    WF: 'Wallis And Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

class E11PhoneNumberComponent {
    constructor(controlContainer) {
        this.controlContainer = controlContainer;
        this.label = '';
        this.id = '';
        this.placeholder = '';
        this.inputClass = '';
        this.hasError = false;
        this.disabled = false;
        this.labelClass = '';
        this.value = null;
        this.country = 'US';
        this.countryCodes = ['US', 'CA'];
        this.showCountrySearch = false;
        this.shouldValidate = true;
        this.required = false;
        this.labelSize = 'sm';
        // @Deprecated: please use formControlName instead
        this.parentForm = new UntypedFormGroup({});
        this.loading = false;
        this.labelTextOptional = '(Optional)';
        this.valueUpdated = new EventEmitter();
        this.showCountryDropdown = false;
        this.dialCode = '1';
        this.countries = Countries;
    }
    ngOnInit() {
        if (!this.countryCodes.length) {
            this.countryCodes = getCountries();
        }
        this.loadCountries();
        this.changeSelectedCountry(this.country);
        this.checkRequired();
    }
    ngAfterViewInit() {
        const phoneNumber = this.getPhoneNumber(this.value);
        if (phoneNumber) {
            const country = this.countryCodes.includes(phoneNumber.country) ? phoneNumber.country : this.country;
            setTimeout(() => {
                this.changeSelectedCountry(country);
                this.maskInput(phoneNumber?.nationalNumber);
            }, 100);
        }
    }
    onInputChange(event) {
        const value = event.target.value === '' || event.target.value === undefined ? null : event.target.value;
        let phoneNumber = this.getPhoneNumber(value);
        if (phoneNumber && phoneNumber.country !== this.country && this.countryCodes.includes(phoneNumber.country)) {
            this.changeSelectedCountry(phoneNumber.country);
            phoneNumber = this.getPhoneNumber(value); // rephrase phone  number
        }
        if (this.onChange) {
            this.onChange(phoneNumber?.number ?? value);
            this.onTouched();
            this.runValidator();
        }
        this.emitForValueWithoutFormControl(phoneNumber, value);
        if (phoneNumber === null)
            return;
        this.maskInput(value);
    }
    emitForValueWithoutFormControl(phoneNumber, initialInput) {
        this.hasError = false;
        this.valueUpdated.emit(phoneNumber?.number ?? initialInput);
        if (!this.required && phoneNumber === null) {
            return;
        }
        if (!phoneNumber || (this.shouldValidate && !this.isPhoneNumberValid(phoneNumber))) {
            this.hasError = true;
        }
    }
    getPhoneNumber(input) {
        if (!input) {
            return null;
        }
        try {
            return parsePhoneNumber(input, this.country);
        }
        catch (e) {
            return null;
        }
    }
    maskInput(input) {
        if (input.length == 4) {
            // fix for deleting digits in brackets
            return;
        }
        this.inputRef.nativeElement.value = new AsYouType(this.country).input(input);
    }
    writeValue(value) {
        this.value = value === '' || value === undefined ? null : value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    isPhoneNumberValid(phoneNumber = null) {
        return !(phoneNumber === null || !isValidNumberForRegion(phoneNumber.nationalNumber, this.country));
    }
    registerOnValidatorChange(fn) {
        this.runValidator = fn;
    }
    validate(control) {
        const phoneNumber = this.getPhoneNumber(control.value);
        if (control.value && this.shouldValidate && !this.isPhoneNumberValid(phoneNumber)) {
            this.hasError = true;
            return {
                phoneNumber: true,
            };
        }
        this.hasError = false;
        return null;
    }
    toggleCountryDropdown() {
        if (this.countryCodes.length <= 1) {
            return;
        }
        this.showCountryDropdown = !this.showCountryDropdown;
    }
    changeSelectedCountry(country = 'US', toggleDropdown = false) {
        this.searchResult = [];
        this.country = country;
        this.dialCode = getCountryCallingCode(this.country);
        // @ts-ignore
        this.maskInput(this.inputRef.nativeElement.value);
        if (this.runValidator != undefined) {
            this.runValidator();
        }
        if (toggleDropdown) {
            this.inputRef.nativeElement.focus();
            this.toggleCountryDropdown();
        }
    }
    loadCountries() {
        const result = {};
        for (const [key, value] of Object.entries(Countries)) {
            if (this.countryCodes.includes(key.toUpperCase())) {
                result[key] = value;
            }
        }
        this.countries = result;
    }
    search(query) {
        const result = [];
        for (const [key, value] of Object.entries(this.countries)) {
            if (value.toLowerCase().includes(query.toLowerCase())) {
                result.push(key);
            }
        }
        this.searchResult = result;
    }
    trackByIndex(index, country) {
        return index;
    }
    onClick(targetElement) {
        if (this.showCountryDropdown) {
            const clickedInside = this.dropdownRef?.nativeElement?.contains(targetElement) || this.dropdownControl?.nativeElement?.contains(targetElement);
            if (!clickedInside) {
                this.toggleCountryDropdown();
            }
        }
    }
    onKeydownHandler(event) {
        if (this.showCountryDropdown && event.key === 'Escape') {
            this.toggleCountryDropdown();
        }
    }
    checkRequired() {
        if (this.controlContainer && this.controlContainer.control instanceof FormGroup) {
            const formControl = this.controlContainer.control.get(this.formControlName || '');
            if (!formControl)
                return;
            this.required = formControl.hasValidator(Validators.required);
        }
        else {
            throw new Error('FormControlName must be used within a parent FormGroup.');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberComponent, deps: [{ token: i1.ControlContainer, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11PhoneNumberComponent, selector: "e11-phone-number", inputs: { label: "label", id: "id", placeholder: "placeholder", inputClass: "inputClass", hasError: "hasError", disabled: "disabled", labelClass: "labelClass", value: "value", country: "country", countryCodes: "countryCodes", showCountrySearch: "showCountrySearch", shouldValidate: "shouldValidate", required: "required", labelSize: "labelSize", formControlName: "formControlName", parentForm: "parentForm", loading: "loading", tooltipConfig: "tooltipConfig", labelTextOptional: "labelTextOptional" }, outputs: { valueUpdated: "valueUpdated" }, host: { listeners: { "document:click": "onClick($event.target)", "document:keydown": "onKeydownHandler($event)" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => E11PhoneNumberComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => E11PhoneNumberComponent),
                multi: true,
            },
        ], viewQueries: [{ propertyName: "inputRef", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "dropdownRef", first: true, predicate: ["dropdown"], descendants: true }, { propertyName: "dropdownControl", first: true, predicate: ["dropdownControl"], descendants: true, static: true }], ngImport: i0, template: "<div>\n  <e11-input-label\n    [for]=\"id\"\n    [label]=\"label\"\n    [hasError]=\"hasError\"\n    [required]=\"required\"\n    [labelClassOverrides]=\"labelClass\"\n    [disabled]=\"disabled\"\n    [size]=\"labelSize\"\n    [tooltipConfig]=\"tooltipConfig\"\n    [labelTextOptional]=\"labelTextOptional\"\n  ></e11-input-label>\n  <div class=\"e11-flex e11-relative e11-rounded-md e11-shadow-sm\">\n    <!--    Country Dropdown -->\n    <div>\n      <button\n        [disabled]=\"disabled || loading\"\n        #dropdownControl\n        type=\"button\"\n        (click)=\"toggleCountryDropdown()\"\n        class=\"e11-bg-white e11-rounded-sm e11-px-4 e11-py-2 e11-border-gray-400 e11-border disabled:e11-opacity-50 disabled:e11-cursor-not-allowed\"\n        [ngClass]=\"{\n          'e11-border-red-700 e11-text-skin-error e11-placeholder-red-700 focus:e11-ring-red-700 focus:e11-border-red-700': hasError,\n          'focus:e11-border-skin-primary': !hasError\n        }\"\n      >\n        <div class=\"e11-flex e11-items-center\">\n          <span class=\"fi fi-{{ country.toLowerCase() }}\"></span> <span class=\"e11-ml-1\">+{{ dialCode }}</span>\n          <span *ngIf=\"countryCodes.length > 1\" class=\"material-icons e11-ml-2 e11-text-right\"> expand_more </span>\n        </div>\n      </button>\n    </div>\n\n    <input *ngIf=\"loading\" class=\"e11-skeleton e11-w-full e11-cursor-wait\" disabled autocomplete=\"off\" />\n    <input\n      #input\n      [type]=\"!loading ? 'tel' : 'hidden'\"\n      [id]=\"id\"\n      [placeholder]=\"placeholder\"\n      (keyup)=\"onInputChange($event)\"\n      [value]=\"value\"\n      [disabled]=\"disabled\"\n      autocomplete=\"tel-national\"\n      class=\"e11-appearance-none e11-block e11-w-full {{\n        inputClass\n      }} disabled:e11-opacity-50 disabled:e11-cursor-not-allowed e11-placeholder-gray-400\"\n      [ngClass]=\"{\n        'e11-border-skin-error e11-text-skin-error focus:e11-ring-skin-error focus:e11-border-skin-error e11-pr-10': hasError,\n        'e11-border-skin-grey focus:e11-ring-skin-primary focus:e11-border-skin-primary-accent': !hasError,\n        'e11-bg-skin-app-bg': disabled\n      }\"\n    />\n    <div *ngIf=\"hasError\" class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-pr-3 e11-flex e11-items-center e11-pointer-events-none\">\n      <e11-icon-error></e11-icon-error>\n    </div>\n  </div>\n  <!-- Dropdown menu -->\n  <div #dropdown *ngIf=\"showCountryDropdown && countryCodes.length > 1\" id=\"dropdown\">\n    <ul\n      class=\"e11-border e11-border-gray-400 e11-overflow-y-auto e11-max-h-60 e11-absolute e11-py-1 e11-bg-white e11-rounded e11-divide-y e11-divide-gray-100 e11-list-none e11-w-fit e11-z-10\"\n      aria-labelledby=\"dropdownButton\"\n    >\n      <li *ngIf=\"showCountrySearch\">\n        <input\n          value=\"\"\n          [autofocus]=\"true\"\n          type=\"search\"\n          class=\"e11-appearance-none e11-block e11-w-full e11-pr-10 e11-border-white e11-rounded-sm\"\n          placeholder=\"Search Countries\"\n          #searchInput\n          (input)=\"search(searchInput.value)\"\n        />\n      </li>\n      <span *ngIf=\"searchResult.length; else allCountries\">\n        <li *ngFor=\"let countryCode of searchResult; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n          <a\n            href=\"javascript:void(0)\"\n            class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n            (click)=\"changeSelectedCountry(countryCode, true)\"\n          >\n            <span class=\"fi fi-{{ countryCode.toLowerCase() }}\"></span> {{ countries[countryCode] || countryCode }}\n          </a>\n        </li>\n      </span>\n\n      <ng-template #allCountries>\n        <li *ngFor=\"let countryCode of countryCodes; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n          <a\n            href=\"javascript:void(0)\"\n            class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n            (click)=\"changeSelectedCountry(countryCode, true)\"\n          >\n            <span class=\"fi fi-{{ countryCode.toLowerCase() }}\"></span> {{ countries[countryCode] || countryCode }}\n          </a>\n        </li>\n      </ng-template>\n    </ul>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.E11InputLabelComponent, selector: "e11-input-label", inputs: ["label", "id", "for", "size", "labelClassOverrides", "required", "hasError", "disabled", "darkMode", "requiredMode", "labelTextOptional", "tooltipConfig"] }, { kind: "component", type: i4.E11IconErrorComponent, selector: "e11-icon-error", inputs: ["classOverrides"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-phone-number', encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => E11PhoneNumberComponent),
                            multi: true,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => E11PhoneNumberComponent),
                            multi: true,
                        },
                    ], template: "<div>\n  <e11-input-label\n    [for]=\"id\"\n    [label]=\"label\"\n    [hasError]=\"hasError\"\n    [required]=\"required\"\n    [labelClassOverrides]=\"labelClass\"\n    [disabled]=\"disabled\"\n    [size]=\"labelSize\"\n    [tooltipConfig]=\"tooltipConfig\"\n    [labelTextOptional]=\"labelTextOptional\"\n  ></e11-input-label>\n  <div class=\"e11-flex e11-relative e11-rounded-md e11-shadow-sm\">\n    <!--    Country Dropdown -->\n    <div>\n      <button\n        [disabled]=\"disabled || loading\"\n        #dropdownControl\n        type=\"button\"\n        (click)=\"toggleCountryDropdown()\"\n        class=\"e11-bg-white e11-rounded-sm e11-px-4 e11-py-2 e11-border-gray-400 e11-border disabled:e11-opacity-50 disabled:e11-cursor-not-allowed\"\n        [ngClass]=\"{\n          'e11-border-red-700 e11-text-skin-error e11-placeholder-red-700 focus:e11-ring-red-700 focus:e11-border-red-700': hasError,\n          'focus:e11-border-skin-primary': !hasError\n        }\"\n      >\n        <div class=\"e11-flex e11-items-center\">\n          <span class=\"fi fi-{{ country.toLowerCase() }}\"></span> <span class=\"e11-ml-1\">+{{ dialCode }}</span>\n          <span *ngIf=\"countryCodes.length > 1\" class=\"material-icons e11-ml-2 e11-text-right\"> expand_more </span>\n        </div>\n      </button>\n    </div>\n\n    <input *ngIf=\"loading\" class=\"e11-skeleton e11-w-full e11-cursor-wait\" disabled autocomplete=\"off\" />\n    <input\n      #input\n      [type]=\"!loading ? 'tel' : 'hidden'\"\n      [id]=\"id\"\n      [placeholder]=\"placeholder\"\n      (keyup)=\"onInputChange($event)\"\n      [value]=\"value\"\n      [disabled]=\"disabled\"\n      autocomplete=\"tel-national\"\n      class=\"e11-appearance-none e11-block e11-w-full {{\n        inputClass\n      }} disabled:e11-opacity-50 disabled:e11-cursor-not-allowed e11-placeholder-gray-400\"\n      [ngClass]=\"{\n        'e11-border-skin-error e11-text-skin-error focus:e11-ring-skin-error focus:e11-border-skin-error e11-pr-10': hasError,\n        'e11-border-skin-grey focus:e11-ring-skin-primary focus:e11-border-skin-primary-accent': !hasError,\n        'e11-bg-skin-app-bg': disabled\n      }\"\n    />\n    <div *ngIf=\"hasError\" class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-pr-3 e11-flex e11-items-center e11-pointer-events-none\">\n      <e11-icon-error></e11-icon-error>\n    </div>\n  </div>\n  <!-- Dropdown menu -->\n  <div #dropdown *ngIf=\"showCountryDropdown && countryCodes.length > 1\" id=\"dropdown\">\n    <ul\n      class=\"e11-border e11-border-gray-400 e11-overflow-y-auto e11-max-h-60 e11-absolute e11-py-1 e11-bg-white e11-rounded e11-divide-y e11-divide-gray-100 e11-list-none e11-w-fit e11-z-10\"\n      aria-labelledby=\"dropdownButton\"\n    >\n      <li *ngIf=\"showCountrySearch\">\n        <input\n          value=\"\"\n          [autofocus]=\"true\"\n          type=\"search\"\n          class=\"e11-appearance-none e11-block e11-w-full e11-pr-10 e11-border-white e11-rounded-sm\"\n          placeholder=\"Search Countries\"\n          #searchInput\n          (input)=\"search(searchInput.value)\"\n        />\n      </li>\n      <span *ngIf=\"searchResult.length; else allCountries\">\n        <li *ngFor=\"let countryCode of searchResult; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n          <a\n            href=\"javascript:void(0)\"\n            class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n            (click)=\"changeSelectedCountry(countryCode, true)\"\n          >\n            <span class=\"fi fi-{{ countryCode.toLowerCase() }}\"></span> {{ countries[countryCode] || countryCode }}\n          </a>\n        </li>\n      </span>\n\n      <ng-template #allCountries>\n        <li *ngFor=\"let countryCode of countryCodes; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n          <a\n            href=\"javascript:void(0)\"\n            class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n            (click)=\"changeSelectedCountry(countryCode, true)\"\n          >\n            <span class=\"fi fi-{{ countryCode.toLowerCase() }}\"></span> {{ countries[countryCode] || countryCode }}\n          </a>\n        </li>\n      </ng-template>\n    </ul>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.ControlContainer, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }], propDecorators: { label: [{
                type: Input
            }], id: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], inputClass: [{
                type: Input
            }], hasError: [{
                type: Input
            }], disabled: [{
                type: Input
            }], labelClass: [{
                type: Input
            }], value: [{
                type: Input
            }], country: [{
                type: Input
            }], countryCodes: [{
                type: Input
            }], showCountrySearch: [{
                type: Input
            }], shouldValidate: [{
                type: Input
            }], required: [{
                type: Input
            }], labelSize: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], loading: [{
                type: Input
            }], tooltipConfig: [{
                type: Input
            }], labelTextOptional: [{
                type: Input
            }], valueUpdated: [{
                type: Output
            }], inputRef: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], dropdownRef: [{
                type: ViewChild,
                args: ['dropdown', { static: false }]
            }], dropdownControl: [{
                type: ViewChild,
                args: ['dropdownControl', { static: true }]
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class E11PhoneNumberModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberModule, declarations: [E11PhoneNumberComponent], imports: [CommonModule, E11InputLabelModule, E11IconModule], exports: [E11PhoneNumberComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberModule, imports: [CommonModule, E11InputLabelModule, E11IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11PhoneNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11PhoneNumberComponent],
                    imports: [CommonModule, E11InputLabelModule, E11IconModule],
                    exports: [E11PhoneNumberComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11PhoneNumberComponent, E11PhoneNumberModule };
